import React, { useState } from "react";
import Category from "./Category";
import NavbarMenu from "./NavbarMenu";
import { Link } from "react-router-dom";
import Loading from "../shared/Loading";

import { getItemStorage } from "../../Localstorage/useLocalStorage";
import { limitString } from "../../helper/helper";

export const menu = [
  { name: "صفحه اصلی", link: "/" },
  { name: "فروشگاه", link: "/shop" },
  { name: "آموزشگاه", link: "/courses" },
  { name: "مجله", link: "/magazine" },
  { name: "درباره ما", link: "/about-us" },
  { name: "تماس با ما", link: "/contact-us" },
  { name: "هیئت علمی", link: "/faculty" },
  // { name: "ثبت نام وبینار", link: "/webinar" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [authFormOpen, setAuthFormOpen] = useState(false);

  const localStorage = getItemStorage("token");

  return (
    <nav className="header-navbar flex justify-between items-center gap-5 py-3">
      {/* category */}

      {/* navbar menu */}
      <div className="navbar-menu">
        <ul className="flex items-center gap-3 text-gray-800">
          {menu.map((m) => (
            <NavbarMenu data={m} />
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
